import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { useI18n } from '@/hooks/useI18n';

interface EmailFieldsProps {
    emailSubject: string;
    customMessage: string;
    onEmailSubjectChange: (value: string) => void;
    onCustomMessageChange: (value: string) => void;
    subjectPlaceholder: string;
}

export const EmailFields = ({
    emailSubject,
    customMessage,
    onEmailSubjectChange,
    onCustomMessageChange,
    subjectPlaceholder
}: EmailFieldsProps) => {
    const { t } = useI18n();

    return (
        <div className="space-y-4">
            {/* Email Subject */}
            <div className="space-y-2">
                <Label htmlFor="email-subject" className="text-sm font-medium">
                    {t('itinerary.emailSubject')}
                </Label>
                <Input
                    id="email-subject"
                    value={emailSubject}
                    onChange={(e) => onEmailSubjectChange(e.target.value)}
                    placeholder={subjectPlaceholder}
                    className="w-full"
                />
            </div>

            {/* Custom Message */}
            <div className="space-y-2">
                <Label htmlFor="custom-message" className="text-sm font-medium">
                    {t('itinerary.customMessage')}
                </Label>
                <Textarea
                    id="custom-message"
                    value={customMessage}
                    onChange={(e) => onCustomMessageChange(e.target.value)}
                    placeholder={t('itinerary.customMessagePlaceholder')}
                    rows={4}
                    className="w-full resize-none"
                />
            </div>
        </div>
    );
};
